module.exports = __webpack_public_path__ + "img/hz_3.2f45666b.jpg";